import React, { Fragment } from 'react';
import ReactTooltip from 'react-tooltip';
import Modal from 'react-modal';
import { get } from '../../../server/actions';
import { getMenuOptions } from '../../Misc/MenuOptions/menuOptionsActions';
import { MenuOrderTypes, MealTypesReports, MealTypes, getPageSizeForPrintByCountry } from '../../../server/constants';
import {
    _addNotification, _addNotificationError,
    getGradeNumberByText, getSchoolGrades, groupBy, LableTemplates
} from "../../../server/util";
import { LabelOptions, preparePrintLabelPageContent, preparePrintLabelStyles } from './printLabelsTemplates/printLabelTemplate';
import { getManageSchoolSettingList } from '../ManageSchools/manageSchoolSettings';
const currentDay = new Date()
let current_Day = (currentDay.getMonth() + 1) + '/' + currentDay.getDate() + '/' + currentDay.getFullYear();
let gradeList = [];

/**
 * The sheet is laid out at exact Avery die-cut coordinates, so any print-dialog
 * scaling or extra page margin shifts every label off its backing. Every browser
 * can print these correctly; only the wording of the settings differs.
 */
const getPrintSettingsGuidance = () => {
    const ua = (typeof navigator !== 'undefined' && navigator.userAgent) || '';
    // Order matters: Edge's UA contains "Chrome", and Chrome's contains "Safari".
    if (/Firefox\//.test(ua)) {
        return {
            browser: 'Firefox',
            steps: [
                'Scale: 100% - Firefox defaults to "Fit to page width", which shrinks the labels',
                'Margins: None',
                'Uncheck "Print headers and footers"'
            ]
        };
    }
    if (/Edg\//.test(ua)) {
        return {
            browser: 'Edge',
            steps: [
                'Scale: 100% (not "Fit to printable area")',
                'Margins: Default',
                'Under "More settings", uncheck "Headers and footers"'
            ]
        };
    }
    if (/Chrome\//.test(ua) || /Chromium\//.test(ua)) {
        return {
            browser: 'Chrome',
            steps: [
                'Scale: 100% (not "Fit to printable area")',
                'Margins: Default',
                'Under "More settings", uncheck "Headers and footers"'
            ]
        };
    }
    if (/Safari\//.test(ua)) {
        return {
            browser: 'Safari',
            steps: [
                'Scale: 100% - turn off "Scale to fit"',
                'Uncheck "Print headers and footers"',
                'Safari honours page margins less reliably than Chrome, Edge or Firefox - if a run comes out misaligned, reprint it from one of those'
            ]
        };
    }
    return {
        browser: 'browser',
        steps: [
            'Scale: 100% - turn off any "fit to page" or "shrink to fit" option',
            'Margins: None or Default (do not set a custom margin)',
            'Turn off page headers and footers'
        ]
    };
};



const deleteStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '30%',
        maxHeight: '85vh',
        overflowY: 'auto',
        transform: 'translate(-50%, -50%)'
    }
};
class PrintLabels extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            pageSize: getPageSizeForPrintByCountry(),
            schoolYear: this.props.schoolYear,
            selectedDate: this.props.selectedDate,
            selectedEndDate: this.props.selectedEndDate,
            schoolId: this.props.schoolId,
            mealType: (getMenuOptions()[0] || ''),
            showModal: false,
            selectedOptions: Object.keys(LabelOptions).filter(k => k !== 'allergies'),
            selectedLabelSize: 1,
            showEntree: true,
            showAlaCarte: true,
            labelByItem: false,
            fontSize: 10
        }
    }
    componentDidMount = () => {
        this.getSelectedLabelTemplate();

    }
    componentWillReceiveProps = (nextProps) => {
        this.setState({
            schoolYear: nextProps.schoolYear,
            selectedDate: nextProps.selectedDate,
            selectedEndDate: nextProps.selectedEndDate,
            schoolId: nextProps.schoolId,
            pageSize: getPageSizeForPrintByCountry()
        });
    }
    getSelectedLabelTemplate = () => {
        getManageSchoolSettingList(sessionStorage.getItem('SchoolId')).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            const selectedSchoolYearRec = data._embedded.schoolYears.find(col => {
                return col.schoolYear == sessionStorage.getItem('schoolYearValue');
            });
            if (selectedSchoolYearRec) {
                this.setState({ selectedLabelSize: selectedSchoolYearRec.labelSize || 1 })
            }
        });
    }

    getDailyReportDataForLabels = () => {
        const { schoolYear, selectedDate, selectedEndDate, schoolId } = this.state;
        let _self = this;
        this.setState({ loading: true });
        if (this.props.mealType === MealTypesReports.LUNCH ||
            this.props.mealType === MealTypesReports.BREAKFAST ||
            this.props.mealType === MealTypesReports.DINNER ||
            this.props.mealType === MealTypesReports.SNACK) {
            const mType = this.props.mealType;
            get(`/transactions/studentsWithOrderedItemV2?isVersion2=true&menuType=${mType}
        &schoolYear=${schoolYear}&selectedDate=${selectedDate}&endDate=${selectedEndDate}&mealSchoolId=${schoolId}&access_token=`).then((response) => {
                if (!response.ok) {
                    if (response.status === 417) {
                        return response.json();
                    }
                }
                console.log('response', response);
                return response;
            }).then(res => {
                if (res.statusCode === 417) {
                    throw Error(res.statusMessage);
                } else if (!res.statusCode === 200) {
                    throw Error(res.errorCode);
                } else {
                    return res.json();
                }
            }).then(res => {
                if (res.statusCode == 200) {
                    const schoolName = JSON.parse(sessionStorage.getItem('loggedInUserInfo')).schoolName;
                    if ((res.studentDetailsWithOrderedItems || []).length > 0) {
                        this.setState({
                            data: (res.studentDetailsWithOrderedItems || []).map(rec => {
                                return { ...rec, schoolName }
                            }), loading: false
                        }, () => {
                            this.printing();
                        });
                    } else {
                        this.props.showErrorMessage('Orders not available for today.');
                    }
                } else {
                    this.setState({ loading: false });
                }
            }).catch(
                (error) => {
                    let msg = ''
                    if (typeof error === 'string') {
                        msg = error;
                    } else {
                        msg = error.message;
                    }
                    this.props.showErrorMessage(msg);
                    this.setState({ loading: false })
                }
            );
        }
    }

    printing = () => {
        const { pageSize, schoolId, selectedOptions, data, selectedLabelSize, showEntree, showAlaCarte, labelByItem, fontSize } = this.state;
        const { isCaterer, grade, onlyExtraItems } = this.props;
        const _gradeValueSortList = (getSchoolGrades((isCaterer ? schoolId : 0), false).sort((a, b) => {
            return a.displayOrder - b.displayOrder;
        })).map(item => {
            return item.value
        });


        let contents = preparePrintLabelPageContent({
            pageSize, schoolId, selectedOptions, isCaterer, grade
            , _gradeValueSortList, data, onlyExtraItems, labelSize: selectedLabelSize,
            showEntree, showAlaCarte, labelByItem, fontSize
        });
        // let contents = (this.prepareBodyContent());
        let styles = preparePrintLabelStyles({ pageSize });
        let frame1 = document.createElement('iframe');
        frame1.name = "frame1";
        frame1.style.position = "absolute";
        frame1.style.top = "-1000000px";
        // The sheet is laid out at real page width, so give the frame that width
        // rather than the 300px iframe default.
        frame1.style.width = pageSize.w;
        frame1.style.height = pageSize.h;
        document.body.appendChild(frame1);
        let frameDoc = frame1.contentWindow ? frame1.contentWindow : frame1.contentDocument.document ? frame1.contentDocument.document : frame1.contentDocument;
        frameDoc.document.open();
        frameDoc.document.write('<html><head><title></title>');
        frameDoc.document.write(styles);
        frameDoc.document.write('</head><body>');
        frameDoc.document.write(contents);
        frameDoc.document.write('</body></html>');
        frameDoc.document.close();
        setTimeout(() => {
            window.frames["frame1"].focus();
            window.frames["frame1"].print();
            document.body.removeChild(frame1);
        }, 500);
        return false;
    }

    //prepareBodyContent = () => {
    /*   
                const resData=(res.studentDetailsWithOrderedItems||[]).sort((a,b)=>{   
                    const aName=`${a.firstName} ${a.lastName}`;
                    const bName=`${b.firstName} ${b.lastName}`;                     
                    if (aName < bName) return -1;
                    if (aName > bName) return 1;
                        return 0;
                }).sort((a,b)=>{
                    if (a.teacherName < b.teacherName) return -1;
                    if (a.teacherName > b.teacherName) return 1;
                        return 0;
                })*/
    /* const { pageSize, schoolId, selectedOptions } = this.state;
    const { isCaterer } = this.props;
    const _grade = this.props.grade || [];
    const _gradeValueSortList = (getSchoolGrades((isCaterer ? schoolId : 0), false).sort((a, b) => {
        return a.displayOrder - b.displayOrder;
    })).map(item => {
        return item.value
    });

    let content = `<div style="width: ${pageSize.w}; margin: 0.4in auto auto 0.1in;">`;
    let pageBreakCount = 12;
    let data = (this.state.data || []).filter((itm) => {
        if (_grade.length === 0) {
            return true;
        } else if (_grade.includes(itm.gradeName)) {
            return true;
        } else {
            return false;
        }
    });
    let lblCount = 0;
    let rowCount = 1;
    _gradeValueSortList.map(grade => {
        const _gradeGroup = groupBy(data, 'gradeName');
        if ((_gradeGroup[grade] || []).length > 0) {
            const selectedGroupData = (_gradeGroup[grade] || [])
            const teacherGroup = groupBy(selectedGroupData, 'teacherName');
            const sortedTeachers = Object.keys(teacherGroup || {}).sort((a, b) => {
                if (a < b) return -1;
                if (a > b) return 1;
                return 0;
            });
            sortedTeachers.map(teacher => {
                const data = (teacherGroup[teacher] || []).sort((a, b) => {
                    const aName = `${a.lastName} ${a.firstName}`;
                    const bName = `${b.lastName} ${b.firstName}`;
                    if (aName < bName) return -1;
                    if (aName > bName) return 1;
                    return 0;
                });
                data.map((item, i) => {
                    let menuItems = [];
                    let menuObjItems = [];
                    if (this.props.onlyExtraItems) {
                        ((item.menuByType || {})['EXTRA'] || []).map(meal => {
                            menuItems.push(`${meal.mealName} -${meal.qty}`);
                            menuObjItems.push({ item: `${meal.mealName} -${meal.qty}`, date: meal.mealDate });
                        });
                    } else {
                        [...((item.menuByType || {})['ENTREE'] || []), ...((item.menuByType || {})['MEAL'] || [])].map(meal => {
                            menuItems.push(`${meal.mealName} -${meal.qty}`);
                            menuObjItems.push({ item: `${meal.mealName} -${meal.qty}`, date: meal.mealDate });
                        });
                        ((item.menuByType || {})[MealTypes.SNACK.toUpperCase()] || []).map(meal => {
                            menuItems.push(`${meal.mealName} -${meal.qty}`);
                            menuObjItems.push({ item: `${meal.mealName} -${meal.qty}`, date: meal.mealDate });
                        });
                        ((item.menuByType || {})['SIDE'] || []).map(side => {
                            menuItems.push(`${side.mealName} -${side.qty}`);
                            menuObjItems.push({ item: `${side.mealName} -${side.qty}`, date: side.mealDate });
                        });
                        ((item.menuByType || {})['EXTRA'] || []).map(meal => {
                            menuItems.push(`${meal.mealName} -${meal.qty}`);
                            menuObjItems.push({ item: `${meal.mealName} -${meal.qty}`, date: meal.mealDate });
                        });
                        ((item.menuByType || {})[MealTypes.BREAKFAST.toUpperCase()] || []).map(side => {
                            menuItems.push(`${side.mealName} -${side.qty}`);
                            menuObjItems.push({ item: `${side.mealName} -${side.qty}`, date: side.mealDate });
                        });
                    }

                    const dateGroup = groupBy(menuObjItems, 'date');
                    Object.keys(dateGroup).map((dt) => {
                        const lblObj = {
                            title: `${item.lastName}, ${item.firstName}`,
                            sid: item.schoolStudentId,
                            schoolName: item.schoolName,
                            grade: item.gradeName,
                            teacherName: item.teacherName,
                            selectedDate: dt,
                            items: (dateGroup[dt] || []).map(itm => itm.item)//menuItems,
                        }
                        if (lblCount > 0 && ((lblCount % pageBreakCount) == 0) && lblObj.items.length > 0) {
                            content = content + `<div style="clear: left; page-break-after:always;"></div></div><div style="width: ${pageSize.w}; margin: 0.4in auto auto 0.1in;">`;
                        }
                        if (lblObj.items.length > 0) {
                            content = content + createLabel({ lblObj, count: lblCount, rowNo: rowCount, LabelOptions, selectedOptions, isCaterer, schoolId });
                            if (((lblCount + 1) % 3 === 0)) {
                                rowCount++;
                            }
                            lblCount++;
                        }

                    })
                });
            });
        }
    });
    return content + '</div>'; */
    //}


    render() {
        const { isCaterer, schoolId, showButtonAs, buttonLabel } = this.props;
        const gradeGroup = groupBy(getSchoolGrades((isCaterer ? schoolId : 0), false), 'value');
        const { selectedOptions } = this.state;
        const labelTemplate = LableTemplates[this.state.selectedLabelSize] || LableTemplates[1];
        const printGuidance = getPrintSettingsGuidance();
        return (<Fragment>
            {
                showButtonAs === 'label' ?
                    <a data-tip data-for={'lblPrint'}
                        onClick={() => {
                            this.setState({ showModal: true });
                            //this.getDailyReportDataForLabels();
                        }}
                    ><span>{buttonLabel ? buttonLabel : 'Print Labels'}</span></a> :
                    <a data-tip data-for={'lblPrint'}
                        onClick={() => {
                            this.setState({ showModal: true });
                            // this.getDailyReportDataForLabels();
                        }}
                        className="fa fa-print fa-2x"><i /></a>
            }
            <ReactTooltip id={'lblPrint'} aria-haspopup='true' type="dark" effect="float">
                <div style={{ color: '#fff' }}>
                    <p>{'Daily School Reports for ' + ((this.props.grade || []).length == 0 ? 'All Grades' : ('Grades-' + ((this.props.grade || []).map(grd => {
                        return (((gradeGroup[grd] || [])[0] || {}).label || '');
                    }))))}</p>
                    <p>{'(Print Labels- ' + labelTemplate.text + ')'}</p>
                </div>
            </ReactTooltip>
            <Modal
                isOpen={this.state.showModal}
                onRequestClose={() => this.setState({ showModal: false, deleteRec: undefined })}
                style={deleteStyles}
                contentLabel="Publish">
                <div className="modal-header">
                    <h4 className="modal-title modal-title-color" id="deleteLabel">Custom Label Content</h4>
                </div>
                <div className="modal-body">
                    <p>Please select/deselect below options for show/hide content in labels</p>
                    <p>
                        <div className="checkbox">
                            <label>
                                <input type="checkbox" checked={Object.keys(LabelOptions).every(key => this.state.selectedOptions.includes(key))} onClick={(e) => {
                                    if (e.target.checked) {
                                        this.setState({ selectedOptions: Object.keys(LabelOptions) });
                                    } else {
                                        this.setState({ selectedOptions: [] });
                                    }
                                }} />
                                {'All'}
                            </label>
                        </div>
                        {
                            Object.keys(LabelOptions).map((key, i) => {
                                return <div className="checkbox">
                                    <label>
                                        <input type="checkbox" checked={this.state.selectedOptions.includes(key)} onClick={(e) => {
                                            if (e.target.checked) {
                                                const idx = selectedOptions.indexOf(key);
                                                if (idx == -1) {
                                                    selectedOptions.push(key);
                                                    this.setState({ selectedOptions });
                                                }
                                            } else {
                                                const idx = selectedOptions.indexOf(key);
                                                if (idx !== -1) {
                                                    selectedOptions.splice(idx, 1);
                                                    this.setState({ selectedOptions });
                                                }
                                            }
                                        }} />
                                        {LabelOptions[key]}
                                    </label>
                                </div>
                            })
                        }
                    </p>
                    <hr/>
                    <p>
                        <strong>Display Options:</strong>
                        {!this.props.onlyExtraItems ? (
                            <div>
                                <div className="checkbox">
                                    <label>
                                        <input type="checkbox" checked={this.state.showEntree} onChange={(e) => this.setState({ showEntree: e.target.checked })} />
                                        {'Entree'}
                                    </label>
                                </div>
                                <div className="checkbox">
                                    <label>
                                        <input type="checkbox" checked={this.state.showAlaCarte} onChange={(e) => this.setState({ showAlaCarte: e.target.checked })} />
                                        {'A la Carte'}
                                    </label>
                                </div>
                            </div>
                        ) : (
                            <div className="checkbox">
                                <label>
                                    <input type="checkbox" checked={this.state.labelByItem} onChange={(e) => this.setState({ labelByItem: e.target.checked })} />
                                    {'Label by Item'}
                                </label>
                            </div>
                        )}
                    </p>
                    <hr/>
                    <p>
                        <strong>Font Size:</strong>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '6px' }}>
                            <button type="button" className="btn btn-default btn-xs" style={{ border: '1px solid #aaa', background: '#f0f0f0', color: '#333', fontWeight: 'bold' }} onClick={() => this.setState(s => ({ fontSize: Math.max(6, s.fontSize - 1) }))}>-</button>
                            <span style={{ minWidth: '30px', textAlign: 'center' }}>{this.state.fontSize}px</span>
                            <button type="button" className="btn btn-default btn-xs" style={{ border: '1px solid #aaa', background: '#f0f0f0', color: '#333', fontWeight: 'bold' }} onClick={() => this.setState(s => ({ fontSize: Math.min(20, s.fontSize + 1) }))}>+</button>
                        </div>
                    </p>
                    <hr/>
                    <div style={{ padding: '8px 10px', background: '#fcf8e3', border: '1px solid #faebcc', borderRadius: '3px', color: '#8a6d3b', fontSize: '12px' }}>
                        <div>
                            <i className="glyphicon glyphicon-info-sign" style={{ marginRight: '5px' }}></i>
                            <strong>Before you print:</strong> load <strong>{labelTemplate.text}</strong> sheets,
                            then check these settings in the {printGuidance.browser} print dialog:
                        </div>
                        <ul style={{ margin: '6px 0 0 0', paddingLeft: '20px' }}>
                            {printGuidance.steps.map((step, i) => <li key={i}>{step}</li>)}
                        </ul>
                        <div style={{ marginTop: '6px' }}>
                            Labels are positioned to the exact die-cut, so scaling or extra margins will shift every row off the label.
                        </div>
                    </div>
                </div>
                <div className="text-right">
                    <button type="button" className="btn btn-primary btn-xs" style={{ margin: '0' }}
                        onClick={() => this.setState({ showModal: false, selectedOptions: Object.keys(LabelOptions).filter(k => k !== 'allergies'), fontSize: 10 })}><i
                            className="glyphicon glyphicon-remove"
                            style={{ marginRight: '0', paddingLeft: '0' }}></i> Cancel
                    </button>
                    <button type="button" className="btn btn-success btn-xs"
                        style={{ margin: '0 0 0 5px' }} onClick={() => {
                            if (selectedOptions.length > 0) {
                                this.getDailyReportDataForLabels();
                                this.setState({ showModal: false });
                            } else {
                                this.props.showErrorMessage("Please select options");
                            }
                        }}
                        id="deleteConfirm"><i className="glyphicon glyphicon-ok"></i> Ok
                    </button>
                </div>
            </Modal>

        </Fragment >);
    }
}
export default PrintLabels;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Reports/printLabels.jsx